import React, { Component } from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';

import Recos from 'components/productdetail/Recos';
import { getRecoSlotData, shouldRecosUpdate } from 'helpers/RecoUtils';
import { withErrorBoundary } from 'components/common/MartyErrorBoundary';

import { associatedProducts, associatedProductsContainer } from 'styles/components/productdetail/recosDetail.scss';

export class RecosDetail3 extends Component {

  // We don't want this component to re-render when it's either loading, or similarProductRecos haven't changed
  shouldComponentUpdate(nextProps) {
    return shouldRecosUpdate(this.props, nextProps);
  }

  render() {
    const {
      similarProductRecos: {
        janus = {},
        lastReceivedRecoKey
      } = {},
      heartsData, onRecoClicked
    } = this.props;
    // If we have recommendations, render the component.
    const janusData = janus[lastReceivedRecoKey] || {};
    const janusRecos = getRecoSlotData(janusData['detail-ext-search-2'], janusData['detail-3']);
    if (janusRecos) {
      const { title, recos } = janusRecos;
      return (
        <div className={cn(associatedProducts, associatedProductsContainer)}>
          <Recos
            recoType="subRecos"
            title={title}
            recos={recos}
            onRecoClicked={onRecoClicked}
            heartsData={heartsData} />
        </div>
      );
    }
    return null;
  }
}

RecosDetail3.propTypes = {
  params: PropTypes.object.isRequired,
  similarProductRecos: PropTypes.object.isRequired,
  styleId: PropTypes.string.isRequired
};

export default withErrorBoundary('RecosDetail3', RecosDetail3);
